import { Injectable } from '@angular/core';
import { Params,RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';

/**
 * The RouterStateSerializer takes the current RouterStateSnapshot and returns any pertinent information needed.
 * The snapshot contains all information about the state of the router at the given point in time. The entire snapshot
 * is complex and not always needed.
 */
export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
  data: any;
}

@Injectable()
export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const queryParams = routerState.root.queryParams;

    let route = routerState.root;
    let params = route.params;

    while (route.firstChild) {
      route = route.firstChild;
      params = {...params, ...route.params};
    }

    return { url, params, queryParams, data: route.data };
  }
}
